import { gql } from '@urql/core';
import React from 'react';
import { CollegeCardFragment } from '../../../generated/spin-graphql';
import { useCollegeSearchContext } from '../../../pages/colleges';
import { CollegeCard } from '../CollegeCard';
import { ShowMoreCollegeSearchResultsButton } from './CollegeShowMoreSearchResultsButton';

export function CollegeSearchResultsDisplay({
    searchColleges,
}: {
    searchColleges: (s: string, filtersActive: boolean, offset: number, loadMore: boolean) => Promise<any>;
}) {
    // just use the context. it gets populated with default
    const { data: colleges } = useCollegeSearchContext();

    return (
        <div className="container colleges-list-cards">
            {colleges.map((college: CollegeCardFragment, index: number) => (
                <CollegeCard key={`subbed-college-card-${index}`} college={college} />
            ))}
            <ShowMoreCollegeSearchResultsButton searchColleges={searchColleges} />
        </div>
    );
}
